import React from 'react'
import { Link } from 'gatsby'

import {
    EuiText,
    EuiCallOut
  } from '@elastic/eui'

function PrimaryBox() {
  return (
    <EuiCallOut size="m" iconType="alert" title="macOS Software">
        <EuiText>
          <h2>Access your SD Card</h2>
        <ul>
          <li><Link to="/Bewegungserkennung/SD_Karten_Zugriff/Interachy/">Interachy</Link></li>
          <li><Link to="/Bewegungserkennung/SD_Karten_Zugriff/DeepVacuum/">DeepVacuum</Link></li>
          <li><Link to="/Bewegungserkennung/SD_Karten_Zugriff/SiteSucker/">SiteSucker</Link></li>
          <li><Link to="/Bewegungserkennung/SD_Karten_Zugriff/SimpleWget/">SimpleWget</Link></li>
          <li><Link to="/Bewegungserkennung/SD_Karten_Zugriff/DownThemAll/">DownThemAll! (Firefox Addon)</Link></li>
        </ul>
        </EuiText>
    </EuiCallOut>
  );
}

export default PrimaryBox